import type { Option } from "src/pages/UserDashboard/WorkPackets/Cases/case-types.ts";

export const preSubmissionRequiredOptions: Option[] = [
  { title: "No", value: "false" },
  { title: "Yes", value: "true" },
];
